import PropTypes from 'prop-types';

const allowedTimeSlotListProps = {
  title: PropTypes.string.isRequired,
  getNormalTimeSlotProps: PropTypes.func,
  getDisabledTimeSlotProps: PropTypes.func,
  classNames: PropTypes.arrayOf(PropTypes.string),
  renderTermContent: PropTypes.func,
  renderDefinitionContent: PropTypes.func,
  listData: PropTypes.arrayOf(
    PropTypes.shape({
      startsAt: PropTypes.string.isRequired,
      endsAt: PropTypes.string.isRequired,
      isBooked: PropTypes.bool
    }),
  ),
  timeFormat: PropTypes.shape({
    hour: PropTypes.oneOf(['numeric', '2-digit']),
    minute: PropTypes.oneOf(['numeric', '2-digit'])
  }),
  hour12: PropTypes.bool
};

export { allowedTimeSlotListProps };